(function () {
  'use strict';

  function normalize(str) {
    return (str || '').toString().trim().toLowerCase();
  }

  // "data-size-key" puede traer varias opciones separadas por "|" (su
  // equivalente en español Y en inglés — ver gc-como-llevarlo.liquid),
  // porque el tamaño elegido en la ficha llega en el idioma activo.
  function keyMatches(key, rawValue) {
    var normRaw = normalize(rawValue);
    return key.split('|').some(function (k) { return normalize(k) === normRaw; });
  }

  function applySize(section, rawValue) {
    var grid = section.querySelector('[data-gc-cll-grid]');
    var heading = section.querySelector('[data-gc-cll-heading]');
    if (!grid) return;

    var cards = grid.querySelectorAll('.gc-cll-card');
    var taggedCards = Array.prototype.filter.call(cards, function (c) { return c.dataset.sizeKey; });
    var anyMatch = taggedCards.some(function (c) { return keyMatches(c.dataset.sizeKey, rawValue); });

    cards.forEach(function (card) {
      var key = card.dataset.sizeKey;
      if (!key) { card.classList.remove('gc-cll-hide'); return; }
      // si ninguna tarjeta coincide con el valor elegido, no ocultamos nada
      // (mejor mostrar de más que dejar la sección vacía por un texto que no calzó)
      var hide = anyMatch && !keyMatches(key, rawValue);
      card.classList.toggle('gc-cll-hide', hide);
    });

    if (heading && anyMatch) {
      if (!heading.dataset.base) heading.dataset.base = heading.textContent.trim();
      heading.textContent = heading.dataset.base + ' — ' + rawValue;
    }
  }

  function applyToAllSections(value) {
    document.querySelectorAll('.gc-como-llevarlo').forEach(function (section) {
      applySize(section, value);
    });
  }

  document.addEventListener('gc:size-change', function (event) {
    applyToAllSections(event.detail.value);
  });

  // el picker de talla (gc-product.js) puede terminar de cargar y avisar su
  // estado inicial ANTES o DESPUÉS de que este script registre el listener de
  // arriba — según el orden de las secciones en la página — así que además
  // leemos directamente del DOM apenas carga este script, sin depender de
  // ese aviso para el primer filtrado.
  var initiallyChecked = document.querySelector('[data-gc-size-option]:checked');
  if (initiallyChecked) applyToAllSections(initiallyChecked.value);
})();
